enum MatterSuiteRoles {
    shareToCounselShare = 'counsel_share', // don't change or remove this
    accountViewer = 'account_viewer',
    accountCreate = 'account_create',
    accountUpdate = 'account_update',
    trustFundRequestCreate = 'trust_fund_request_create',
    trustFundRequestUpdate = 'trust_fund_request_update',
    trustFundRequestDelete = 'trust_fund_request_delete',
    trustFundRequestApply = 'trust_fund_request_apply',
    trustFundPaymentViewer = 'trust_fund_payment_viewer',
    trustFundPaymentCreate = 'trust_fund_payment_create',
    trustFundCreditNoteViewer = 'trust_fund_credit_note_viewer',
    trustFundCreditNoteCreate = 'trust_fund_credit_note_create',
    matterTemplateAttached = 'matter_template_attached',
    invoiceUpdate = 'invoice_update',
    invoicePaymentReminder = 'invoice_payment_reminder',
    invoiceLogoCustomize = 'invoice_logo_customize',
    invoiceTemplateViewer = 'invoice_template_viewer',
    invoiceTemplateCreate = 'invoice_template_create',
    paymentTermsViewer = 'payment_terms_viewer',
    paymentTermsCreate = 'payment_terms_create',
    invoicePaymentViewer = 'invoice_payment_viewer',
    utbmsSettingUpdate = 'utbms_setting_update',
    invoicePaymentCreate = 'invoice_payment_create',
    invoicePaymentUpdate = 'invoice_payment_update',
    invoicePaymentDelete = 'invoice_payment_delete',
    workflowCreate = 'workflow_create',
    contactCreate = 'contact_create',
    billingSubscriptionPaymentMethodCreate = 'billing_subscription_payment_method_create',
    hourlyRateCreate = 'hourly_rate_create',
    payersCreate = 'payers_create',
    legalResearchCategoryCreate = 'legal_research_category_create',
    legalResearchCategoryUpdate = 'legal_research_category_update',
    taskReminderCreate = 'task_reminder_create',
    workflowViewer = 'workflow_viewer',
    locationUpdate = 'location_update',
    calendarShare = 'calendar_share',
    personalNotesCreate = 'personal_notes_create',
    billingSubscriptionDelete = 'billing_subscription_delete',
    documentViewContactDocumentOnly = 'document_view_contact_document_only',
    matterViewBasicInfo = 'matter_view_basic_info',
    appTypeViewer = 'app_type_viewer',
    billingSubscriptionPaymentMethodUpdate = 'billing_subscription_payment_method_update',
    billingSubscriptionPaymentMethodDelete = 'billing_subscription_payment_method_delete',
    settingsCreate = 'settings_create',
    secureMessageCreate = 'secure_message_create',
    legalResearchLibraryUpdate = 'legal_research_library_update',
    taskTypeCreate = 'task_type_create',
    documentViewer = 'document_viewer',
    invoiceOutstandingViewer = 'invoice_outstanding_viewer',
    contactRelationCreate = 'contact_relation_create',
    reminderCreate = 'reminder_create',
    billingAccountViewer = 'billing_account_viewer',
    exportViewer = 'export_viewer',
    matterNumberUpdate = 'matter_number_update',
    eventTypeViewer = 'event_type_viewer',
    calendarUpdate = 'calendar_update',
    permissionGroupsUpdate = 'permission_groups_update',
    personalNotesUpdate = 'personal_notes_update',
    reportInvoicePaymentViewer = 'report_invoice_payment_viewer',
    firmWorkingHoursUpdate = 'firm_working_hours_update',
    matterBillingInfoViewer = 'matter_billing_info_viewer',
    billingSubscriptionUpdate = 'billing_subscription_update',
    workflowDelete = 'workflow_delete',
    billingSubscriptionCreate = 'billing_subscription_create',
    paymentMethodUpdate = 'payment_method_update',
    paymentMethodDelete = 'payment_method_delete',
    paymentGatewaySettingUpdate = 'payment_gateway_setting_update',
    paymentGatewaySettingDelete = 'payment_gateway_setting_delete',
    matterDelete = 'matter_delete',
    contactRelationViewer = 'contact_relation_viewer',
    communicationViewer = 'communication_viewer',
    matterStatusUpdate = 'matter_status_update',
    locationDelete = 'location_delete',
    taskTypeDelete = 'task_type_delete',
    taskTypeViewer = 'task_type_viewer',
    personalNotesViewer = 'personal_notes_viewer',
    licenseWalletViewer = 'license_wallet_viewer',
    userViewer = 'user_viewer',
    notificationViewer = 'notification_viewer',
    practiceAreaViewer = 'practice_area_viewer',
    activityLogViewer = 'activity_log_viewer',
    expenseCategoryCreate = 'expense_category_create',
    appTypeUpdate = 'app_type_update',
    appTypeDelete = 'app_type_delete',
    locationViewer = 'location_viewer',
    departmentViewer = 'department_viewer',
    secureMessageDelete = 'secure_message_delete',
    tagDelete = 'tag_delete',
    customFieldViewer = 'custom_field_viewer',
    taskViewer = 'task_viewer',
    invoiceViewer = 'invoice_viewer',
    motionDelete = 'motion_delete',
    causeOfActionTemplateViewer = 'cause_of_action_template_viewer',
    motionTypeViewer = 'motion_type_viewer',
    calendarDelete = 'calendar_delete',
    taskTypeUpdate = 'task_type_update',
    billingAccountUpdate = 'billing_account_update',
    notificationDelete = 'notification_delete',
    permissionGroupsViewer = 'permission_groups_viewer',
    reportingCreate = 'reporting_create',
    eventTypeCreate = 'event_type_create',
    documentDelete = 'document_delete',
    calendarEventDelete = 'calendar_event_delete',
    eventTypeUpdate = 'event_type_update',
    customFieldCreate = 'custom_field_create',
    permissionGroupsDelete = 'permission_groups_delete',
    licenseWalletDelete = 'license_wallet_delete',
    licenseWalletUpdate = 'license_wallet_update',
    reportingDelete = 'reporting_delete',
    documentCategoryUpdate = 'document_category_update',
    folderUpdate = 'folder_update',
    calendarCreate = 'calendar_create',
    companyViewer = 'company_viewer',
    designationViewer = 'designation_viewer',
    folderCreate = 'folder_create',
    matterViewer = 'matter_viewer',
    reminderUpdate = 'reminder_update',
    exportCreate = 'export_create',
    exportUpdate = 'export_update',
    departmentUpdate = 'department_update',
    designationUpdate = 'designation_update',
    roleDelete = 'role_delete',
    discoveryViewer = 'discovery_viewer',
    causeOfActionTemplateUpdate = 'cause_of_action_template_update',
    legalResearchCategoryDelete = 'legal_research_category_delete',
    reportingViewer = 'reporting_viewer',
    matterAttachCreate = 'matter_attach_create',
    calendarEventViewer = 'calendar_event_viewer',
    matterAttachViewer = 'matter_attach_viewer',
    matterAttachUpdate = 'matter_attach_update',
    matterAttachDelete = 'matter_attach_delete',
    calendarViewer = 'calendar_viewer',
    staffPerformanceViewer = 'staff_performance_viewer',
    departmentDelete = 'department_delete',
    designationDelete = 'designation_delete',
    tagViewer = 'tag_viewer',
    secureMessageViewer = 'secure_message_viewer',
    permissionGroupsCreate = 'permission_groups_create',
    billingSubscriptionViewer = 'billing_subscription_viewer',
    licenseWalletCreate = 'license_wallet_create',
    calendarEventUpdate = 'calendar_event_update',
    courtUpdate = 'court_update',
    matterUpdate = 'matter_update',
    courtDelete = 'court_delete',
    exportDelete = 'export_delete',
    settingsDelete = 'settings_delete',
    matterStatusUpdateCreate = 'matter_status_update_create',
    taskGroupCreate = 'task_group_create',
    practiceAreaDelete = 'practice_area_delete',
    customFieldSetViewer = 'custom_field_set_viewer',
    matterStageDelete = 'matter_stage_delete',
    matterCreate = 'matter_create',
    causeOfActionTemplateCreate = 'cause_of_action_template_create',
    causeOfActionTemplateDelete = 'cause_of_action_template_delete',
    causeOfActionComplaintViewer = 'cause_of_action_complaint_viewer',
    causeOfActionComplaintUpdate = 'cause_of_action_complaint_update',
    causeOfActionComplaintDelete = 'cause_of_action_complaint_delete',
    motionTypeDelete = 'motion_type_delete',
    reportingTaskProductivityReportViewer = 'reporting_task_productivity_report_viewer',
    calendarEventManageAllEvent = 'calendar_event_manage_all_event',
    calendarEventManageOwnEvent = 'calendar_event_manage_own_event',
    staffProfileUpdate = 'staff_profile_update',
    documentViewMatterDocument = 'document_view_matter_document',
    reportInvoiceViewer = 'report_invoice_viewer',
    billingAccountDelete = 'billing_account_delete',
    firmWorkingHoursViewer = 'firm_working_hours_viewer',
    documentViewCompanyDocumentOnly = 'document_view_company_document_only',
    paymentGatewaySettingCreate = 'payment_gateway_setting_create',
    documentViewAllDocuments = 'document_view_all_documents',
    calendarEventReminderCreate = 'calendar_event_reminder_create',
    calendarEventShareCalendar = 'calendar_event_share_calendar',
    calendaringRulesViewer = 'calendaring_rules_viewer',
    calendaringRulesCreate = 'calendaring_rules_create',
    calendaringRulesDelete = 'calendaring_rules_delete',
    contactGroupViewer = 'contact_group_viewer',
    contactGroupCreate = 'contact_group_create',
    contactGroupUpdate = 'contact_group_update',
    contactGroupDelete = 'contact_group_delete',
    mattersuiteAiViewerFullAiSearch = 'mattersuite_ai_viewer_full_ai_search',
    contactExportData = 'contact_export_data',
    contactViewCommunication = 'contact_view_communication',
    invoiceCreate = 'invoice_create',
    taskManageAllTask = 'task_manage_all_task',
    taskManageOwnTask = 'task_manage_own_task',
    staffUpdatePreference = 'staff_update_preference',
    documentFullTextSearchViewer = 'document_full_text_search_viewer',
    userDashboardViewer = 'user_dashboard_viewer',
    notificationTemplateViewer = 'notification_template_viewer',
    notificationTemplateCreate = 'notification_template_create',
    notificationTemplateUpdate = 'notification_template_update',
    taskKanbanViewer = 'task_kanban_viewer',
    notificationTemplateDelete = 'notification_template_delete',
    startGuideViewer = 'start_guide_viewer',
    dataMigrationViewer = 'data_migration_viewer',
    taskReminderUpdate = 'task_reminder_update',
    staffCreate = 'staff_create',
    appsDropboxViewer = 'apps_dropbox_viewer',
    appsOffice365Viewer = 'apps_office365_viewer',
    documentShare = 'document_share',
    matterTemplateDelete = 'matter_template_delete',
    notificationSmsViewer = 'notification_sms_viewer',
    myDashboardViewer = 'my_dashboard_viewer',
    appsOnedriveViewer = 'apps_onedrive_viewer',
    appsOutlookCalendarViewer = 'apps_outlook_calendar_viewer',
    appsTeamsViewer = 'apps_teams_viewer',
    appsDropboxDocumentsViewer = 'apps_dropbox_documents_viewer',
    appsGoogleDriveViewer = 'apps_google_drive_viewer',
    calendarEventSolDatesViewer = 'calendar_event_sol_dates_viewer',
    reportingOriginatingAttorneyReportViewer = 'reporting_originating_attorney_report_viewer',
    reportingFeeAllocationReportViewer = 'reporting_fee_allocation_report_viewer',
    reportingTaskProgressReportViewer = 'reporting_task_progress_report_viewer',
    reportingFinancialAndActivityReportViewer = 'reporting_financial_and_activity_report_viewer',
    staffDelete = 'staff_delete',
    documentUpdate = 'document_update',
    customFieldSetCreate = 'custom_field_set_create',
    customFieldSetDelete = 'custom_field_set_delete',
    communicationCreate = 'communication_create',
    documentCategoryCreate = 'document_category_create',
    staffProfileViewer = 'staff_profile_viewer',
    activityLogUpdate = 'activity_log_update',
    timeEntryViewer = 'time_entry_viewer',
    timeEntryCreate = 'time_entry_create',
    timeEntryUpdate = 'time_entry_update',
    timeEntryDelete = 'time_entry_delete',
    hourlyRateUpdate = 'hourly_rate_update',
    payersUpdate = 'payers_update',
    expenseCategoryDelete = 'expense_category_delete',
    utbmsSettingViewer = 'utbms_setting_viewer',
    utbmsSettingCreate = 'utbms_setting_create',
    utbmsSettingDelete = 'utbms_setting_delete',
    hourlyRateViewer = 'hourly_rate_viewer',
    payersDelete = 'payers_delete',
    coCounselPortalEnable = 'co_counsel_portal_enable',
    motionTypeCreate = 'motion_type_create',
    intakeFormUpdate = 'intake_form_update',
    intakeFormDelete = 'intake_form_delete',
    eSignatureViewer = 'e_signature_viewer',
    reportViewer = 'report_viewer',
    reportingAdvancedReportViewer = 'reporting_advanced_report_viewer',
    motionTypeUpdate = 'motion_type_update',
    mattersuiteAiViewerLegalResearch = 'mattersuite_ai_viewer_legal_research',
    mattersuiteAiViewerGenerateNda = 'mattersuite_ai_viewer_generate_nda',
    billingSubscriptionPaymentMethodViewer = 'billing_subscription_payment_method_viewer',
    matterViewDocuments = 'matter_view_documents',
    matterShare = 'matter_share',
    matterViewTasks = 'matter_view_tasks',
    staffProfileCreate = 'staff_profile_create',
    staffViewer = 'staff_viewer',
    taskGroupDelete = 'task_group_delete',
    matterStatusUpdateViewer = 'matter_status_update_viewer',
    taskViewAllTask = 'task_view_all_task',
    multilingualViewer = 'multilingual_viewer',
    billingAccountCreate = 'billing_account_create',
    matterViewEvents = 'matter_view_events',
    documentTemplateCreate = 'document_template_create',
    matterKanbanViewer = 'matter_kanban_viewer',
    matterMatterCustomField = 'matter_matter_custom_field',
    invoiceCreditNotesUpdate = 'invoice_credit_notes_update',
    invoiceCreditNotesDelete = 'invoice_credit_notes_delete',
    timeEntryTimerControl = 'time_entry_timer_control',
    taxViewer = 'tax_viewer',
    taxCreate = 'tax_create',
    taxUpdate = 'tax_update',
    taxDelete = 'tax_delete',
    invoiceSettingsViewer = 'invoice_settings_viewer',
    invoiceSettingsCreate = 'invoice_settings_create',
    invoiceNumberDelete = 'invoice_number_delete',
    hourlyRateDelete = 'hourly_rate_delete',
    payersViewer = 'payers_viewer',
    invoiceSettingsUpdate = 'invoice_settings_update',
    invoiceSettingsDelete = 'invoice_settings_delete',
    matterStatusUpdateDelete = 'matter_status_update_delete',
    intakeFormLeadViewer = 'intake_form_lead_viewer',
    intakeFormLeadUpdate = 'intake_form_lead_update',
    intakeFormLeadDelete = 'intake_form_lead_delete',
    mattersuiteAiViewerConflictSearch = 'mattersuite_ai_viewer_conflict_search',
    taskGroupViewer = 'task_group_viewer',
    documentCategoryDelete = 'document_category_delete',
    secureMessageUpdate = 'secure_message_update',
    customFieldDelete = 'custom_field_delete',
    communicationDelete = 'communication_delete',
    contactViewTask = 'contact_view_task',
    contactCustomFields = 'contact_custom_fields',
    activityLogCreate = 'activity_log_create',
    matterBudgetUpdate = 'matter_budget_update',
    contactDelete = 'contact_delete',
    reportMatterViewer = 'report_matter_viewer',
    reportContactViewer = 'report_contact_viewer',
    reportTagViewer = 'report_tag_viewer',
    reportCalendarViewer = 'report_calendar_viewer',
    documentTemplateDelete = 'document_template_delete',
    contactViewer = 'contact_viewer',
    matterViewMotions = 'matter_view_motions',
    paymentTermsUpdate = 'payment_terms_update',
    paymentTermsDelete = 'payment_terms_delete',
    expenseCategoryUpdate = 'expense_category_update',
    invoiceTemplateUpdate = 'invoice_template_update',
    invoiceTemplateDelete = 'invoice_template_delete',
    practiceAreaUpdate = 'practice_area_update',
    intakeFormCreate = 'intake_form_create',
    matterViewCommunication = 'matter_view_communication',
    matterViewCoa = 'matter_view_coa',
    matterViewLegalResearch = 'matter_view_legal_research',
    calendarEventRecurringCreate = 'calendar_event_recurring_create',
    matterViewDiscovery = 'matter_view_discovery',
    matterViewNotes = 'matter_view_notes',
    documentTemplateViewer = 'document_template_viewer',
    userDelete = 'user_delete',
    contactRelationDelete = 'contact_relation_delete',
    invoiceAutomatedReminder = 'invoice_automated_reminder',
    appsViewer = 'apps_viewer',
    timeEntryCategoryUpdate = 'time_entry_category_update',
    timeEntryCategoryDelete = 'time_entry_category_delete',
    folderDelete = 'folder_delete',
    documentCreate = 'document_create',
    companyUpdate = 'company_update',
    contactRelationUpdate = 'contact_relation_update',
    documentCategoryViewer = 'document_category_viewer',
    taskGroupUpdate = 'task_group_update',
    reminderDelete = 'reminder_delete',
    personalNotesDelete = 'personal_notes_delete',
    tagUpdate = 'tag_update',
    matterStatusDelete = 'matter_status_delete',
    companyCreate = 'company_create',
    companyDelete = 'company_delete',
    contactViewPersonalNotes = 'contact_view_personal_notes',
    contactBasicInfo = 'contact_basic_info',
    discoveryUpdate = 'discovery_update',
    motionUpdate = 'motion_update',
    motionCreate = 'motion_create',
    causeOfActionComplaintCreate = 'cause_of_action_complaint_create',
    legalResearchCategoryViewer = 'legal_research_category_viewer',
    activityLogDelete = 'activity_log_delete',
    calendarEventCreate = 'calendar_event_create',
    settingsUpdate = 'settings_update',
    taskViewOwnTask = 'task_view_own_task',
    matterStageUpdate = 'matter_stage_update',
    contactUpdate = 'contact_update',
    eventTypeDelete = 'event_type_delete',
    communicationUpdate = 'communication_update',
    paymentMethodCreate = 'payment_method_create',
    paymentGatewaySettingViewer = 'payment_gateway_setting_viewer',
    departmentCreate = 'department_create',
    designationCreate = 'designation_create',
    accountTransactionWithdrawFund = 'account_transaction_withdraw_fund',
    accountTransactionAddFund = 'account_transaction_add_fund',
    accountTransactionTransferFund = 'account_transaction_transfer_fund',
    matterHistoryViewer = 'matter_history_viewer',
    matterStatusViewer = 'matter_status_viewer',
    matterNumberDelete = 'matter_number_delete',
    courtViewer = 'court_viewer',
    taskUpdate = 'task_update',
    discoveryCreate = 'discovery_create',
    motionViewer = 'motion_viewer',
    staffUpdate = 'staff_update',
    taskDelete = 'task_delete',
    reminderViewer = 'reminder_viewer',
    calendaringRulesUpdate = 'calendaring_rules_update',
    customFieldSetUpdate = 'custom_field_set_update',
    legalResearchLibraryViewer = 'legal_research_library_viewer',
    roleUpdate = 'role_update',
    reportStaffViewer = 'report_staff_viewer',
    reportActivityLogViewer = 'report_activity_log_viewer',
    reportCommunicationViewer = 'report_communication_viewer',
    notificationCreate = 'notification_create',
    practiceAreaCreate = 'practice_area_create',
    matterNumberCreate = 'matter_number_create',
    notificationUpdate = 'notification_update',
    intakeFormViewer = 'intake_form_viewer',
    expenseCategoryViewer = 'expense_category_viewer',
    clientPortalEnable = 'client_portal_enable',
    invoiceEmailToClient = 'invoice_email_to_client',
    tagCreate = 'tag_create',
    roleCreate = 'role_create',
    taskRecurringCreate = 'task_recurring_create',
    courtCreate = 'court_create',
    invoiceDelete = 'invoice_delete',
    discoveryDelete = 'discovery_delete',
    settingsViewer = 'settings_viewer',
    reportingUpdate = 'reporting_update',
    userCreate = 'user_create',
    userUpdate = 'user_update',
    contactViewDocument = 'contact_view_document',
    matterNumberViewer = 'matter_number_viewer',
    reportTimeEntryViewer = 'report_time_entry_viewer',
    locationCreate = 'location_create',
    calendarEventReminderUpdate = 'calendar_event_reminder_update',
    appsSharepointViewer = 'apps_sharepoint_viewer',
    reportTaskViewer = 'report_task_viewer',
    matterStageViewer = 'matter_stage_viewer',
    trustFundRequestViewer = 'trust_fund_request_viewer',
    staffProfileDelete = 'staff_profile_delete',
    timeEntryCategoryViewer = 'time_entry_category_viewer',
    timeEntryCategoryCreate = 'time_entry_category_create',
    invoiceNumberViewer = 'invoice_number_viewer',
    invoiceNumberCreate = 'invoice_number_create',
    invoiceNumberUpdate = 'invoice_number_update',
    legalResearchLibraryDelete = 'legal_research_library_delete',
    matterStageCreate = 'matter_stage_create',
    appTypeCreate = 'app_type_create',
    matterInsightViewer = 'matter_insight_viewer',
    matterStatusCreate = 'matter_status_create',
    folderViewer = 'folder_viewer',
    paymentMethodViewer = 'payment_method_viewer',
    invoiceCreditNotesViewer = 'invoice_credit_notes_viewer',
    invoiceCreditNotesCreate = 'invoice_credit_notes_create',
    invoiceSplitBilling = 'invoice_split_billing',
    invoiceShare = 'invoice_share',
    clientPortalAccessUpdate = 'client_portal_access_update',
    firmDashboardViewer = 'firm_dashboard_viewer',
    taskPriorityViewer = 'task_priority_viewer',
    counselShare = 'counsel_share',
    matterTimeLineViewer = 'matter_time_line_viewer',
    locationGlanceViewer = 'location_glance_viewer',
    locationManagerViewer = 'location_manager_viewer',
    locationManagerUpdate = 'location_manager_update',
    matterBudgetViewer = 'matter_budget_viewer',
    accountTransactionViewer = 'account_transaction_viewer',
    accountTransactionCreate = 'account_transaction_create',
    accountTransactionUpdate = 'account_transaction_update',
    accountTransactionDelete = 'account_transaction_delete',
    accountDelete = 'account_delete',
    matterStatusUpdateUpdate = 'matter_status_update_update',
    customFieldUpdate = 'custom_field_update',
    workflowUpdate = 'workflow_update',
    reportCreditNoteViewer = 'report_credit_note_viewer',
    roleViewer = 'role_viewer',
    legalResearchLibraryCreate = 'legal_research_library_create',
    taskCreate = 'task_create',
    matterTemplateViewer = 'matter_template_viewer',
    documentTemplateUpdate = 'document_template_update',
    reportingTrustAccountReportViewer = 'reporting_trust_account_report_viewer',
    contactViewEvent = 'contact_view_event',
    matterTemplateCreate = 'matter_template_create',
    matterTemplateUpdate = 'matter_template_update',
    expenseTypeCreate = 'expense_type_create',
    expenseTypeDelete = 'expense_type_delete',
    expenseTypeUpdate = 'expense_type_update',
    expenseTypeViewer = 'expense_type_viewer',
    ledgerCreate = 'ledger_create',
    ledgerDelete = 'ledger_delete',
    ledgerUpdate = 'ledger_update',
    ledgerViewer = 'ledger_viewer',
    invoiceActionViewer = 'invoice_actions_viewer'
}

export default MatterSuiteRoles